import React__default, { useState } from 'react';
import { Button, P2 } from '@zooplus/ui-components';
import { useTranslation } from '../../../hooks/use-translations.js';
import { Article } from '../../common/article/Article.js';
import { ProductsTitle } from '../../common/products-title/ProductsTitle.js';
import styles from './ArticleList.module.scss.js';
import '../../../node_modules/@zooplus/commons-lang/dist/es/gen/lang.js';
import { useSiteContext } from '../../../node_modules/@zooplus/commons-lang/dist/es/components/SiteProvider.js';
import '../../../node_modules/@zooplus/commons-lang/dist/es/hooks/use-translation.js';

const ArticleList = (props) => {
    const { site } = useSiteContext();
    const [showProducts, setShowProducts] = useState(false);
    const { t } = useTranslation(site.realm);
    return (React__default.createElement("div", { className: styles.wrapper },
        React__default.createElement(ProductsTitle, { numberOfArticles: props.articles.length }),
        React__default.createElement("ul", { className: styles.articleList },
            props.articles.map((article, index) => (React__default.createElement(React__default.Fragment, null, index <= 2 ? (React__default.createElement("li", { key: article.articleShopId },
                React__default.createElement(Article, { article: article, withLinks: false }))) : (showProducts && (React__default.createElement("li", { key: article.articleShopId },
                React__default.createElement(Article, { article: article, withLinks: false }))))))),
            props.articles.length > 3 && (React__default.createElement(Button, { className: styles.showProductsButton, onClick: () => setShowProducts(!showProducts), size: 'small', "data-testid": "showMoreButton" },
                React__default.createElement(P2, { className: styles.text }, !showProducts
                    ? t('checkout.cart-offer.show-all-articles')
                    : t('checkout.cart-offer.show-less-articles')))))));
};

export { ArticleList };
//# sourceMappingURL=ArticleList.js.map
